import { assets } from './assets.const';
import { ModuleConst } from './keys.constant';

export interface sidebarInterface {
  label: string;
  path?: string;
  icon?: string;
  isSubMenu: boolean;
  sideBarId:number;
  isAdd?: boolean;
  isView?: boolean;
  isDelete?: boolean;
  isEdit?: boolean;
  subMenuItems?: sidebarInterface[];
}
export const sideBar: sidebarInterface[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    sideBarId:ModuleConst.Dashboard,
    icon: assets.DashboardIcon,
    isSubMenu: false
  },
  // {
  //   label: 'Analytics',
  //   path: '/manage-analytics',
  //   sideBarId:ModuleConst.AnalyticsReports,
  //   icon: assets.AnalyticIcon,
  //   isSubMenu: false
  // },
  {
    label: 'Subscribers',
    path: '/manage-user',
    sideBarId:ModuleConst.Subscribers,
    icon: assets.UsersIcon,
    isSubMenu: false
  },
  {
    label: 'Subscriptions',
    path: '/manage-subscription',
    sideBarId:ModuleConst.SubscriptionPlans,
    icon: assets.packageIcon,
    isSubMenu: false,
    subMenuItems: []
  },
  {
    label: 'Payments',
    path: '/manage-payment',
    sideBarId:ModuleConst.Payment,
    icon: assets.payrollIcon,
    isSubMenu: false,
    subMenuItems: []
  },
  {
    label: 'Support',
    path: '/support',
    sideBarId:ModuleConst.Support,
    icon: assets.ReportIcon,
    isSubMenu: false,
    subMenuItems: []
  },
  {
    label: 'Users',
    path: '/manage-users',
    sideBarId:ModuleConst.SubAdmin,
    icon: assets.SubAdminIcon,
    isSubMenu: false,
    subMenuItems: []
  }
];
